import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        {/* Label */}
        <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/50 text-xs font-medium text-foreground-500 tracking-wide mb-8">
          {t("about.label")}
        </span>

        {/* Editorial Title */}
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-light text-foreground-900 leading-[1.3] space-y-2">
          <span className="block">
            {t("about.line1")}{" "}
            <span className="inline-flex items-center mx-1">
              <i className="ri-footprint-line text-primary-500 text-3xl md:text-4xl"></i>
            </span>
          </span>
          <span className="block">
            <span className="inline-flex items-center mx-1">
              <i className="ri-t-shirt-line text-accent-500 text-3xl md:text-4xl"></i>
            </span>{" "}
            {t("about.line2")}
          </span>
          <span className="block">
            {t("about.line3")}{" "}
            <span className="inline-flex items-center mx-1">
              <i className="ri-handbag-line text-secondary-600 text-3xl md:text-4xl"></i>
            </span>
          </span>
        </h2>

        <p className="mt-8 text-foreground-600 leading-relaxed max-w-2xl mx-auto text-sm md:text-base">
          Kakobuy Spreadsheet to kompleksowe narzędzie, które rewolucjonizuje sposób, w jaki robisz zakupy z Chin.
          Dzięki naszemu arkuszowi zyskujesz dostęp do sprawdzonych produktów, kategorii i bezpośrednich linków,
          oszczędzając czas i pieniądze przy każdym zamówieniu.
        </p>
      </div>
    </section>
  );
}